export default {
	isMetricSystem() {
		var language = window.navigator.userLanguage || window.navigator.language;
		return !language || (language.toLowerCase().indexOf('us') === -1 && language.toLowerCase().indexOf('gb') === -1);
	},
	kmOrMiles() {
		return this.isMetricSystem() ? 'km' : 'miles';
	},
	metricMultiplier() {
		return this.isMetricSystem() ? 1000 : 1609.344;
	},
	getMetricMultipliedValue(v) {
		return Math.round(v * this.metricMultiplier() * 100)/100;
	},
	getRadiusDividedValue(v) {
		return Math.round(v / this.metricMultiplier() * 100)/100;
	}
};
